"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var components_1 = require("@idp/duc/components");
var utils_1 = require("@idp/ui-components/utils");
var Utils = require("../../../../utils/UtilityFunctions");
var styles = require("./UnauthAccess.scss");
var ReportingService_1 = require("../../../../api/ReportingService");
var CartConfiguration_scss_1 = require("../../../CartConfigurationContainer/CartConfiguration.scss");
var UnauthAccess = /** @class */ (function (_super) {
    __extends(UnauthAccess, _super);
    function UnauthAccess(props) {
        var _this = _super.call(this, props) || this;
        _this.signInText = 'Sign in to view';
        _this.onSignIn = _this.onSignIn.bind(_this);
        _this.reportingService = new ReportingService_1.default();
        return _this;
    }
    UnauthAccess.prototype.onSignIn = function () {
        var redirectionURL = Utils.isLoginRequiredonCart() ? Utils.getauthenticatedPersistantLoginURL() : '';
        this.reportingService.fireLinkClickWithOutPageLoad(this.signInText, redirectionURL);
        window.location.href = redirectionURL;
    };
    UnauthAccess.prototype.render = function () {
        var isACPMsgShouldBeShown = !!(Utils.getIXPFlagValue('svc-show-acp-message'));
        return (React.createElement("div", null,
            React.createElement("div", { className: styles.solidlineGrey }),
            React.createElement("div", { className: "flex justify-between" },
                React.createElement("div", { className: styles.content18px }, "See details about your wireless pricing, billing, and more."),
                React.createElement("div", { className: styles.linkWidth },
                    React.createElement(components_1.Link, { kind: "utilityPrimary", testId: utils_1.default('', 'Link', this.signInText), onClick: this.onSignIn, "aria-label": this.signInText, className: [CartConfiguration_scss_1.commonLinkSmall, styles.linkTextDecoration] }, this.signInText))),
            React.createElement("div", { className: styles.solidlineGrey }),
            React.createElement("div", null,
                React.createElement("div", { className: styles.content24px }, "Savings & promotions"),
                React.createElement("div", { className: "pad-t-xs" },
                    React.createElement(components_1.Link, { kind: "utilityPrimary", testId: utils_1.default('', 'Link', this.signInText), onClick: this.onSignIn, "aria-label": this.signInText, className: [CartConfiguration_scss_1.commonLinkSmall, styles.linkTextDecoration] }, this.signInText)),
                isACPMsgShouldBeShown && React.createElement("div", { className: styles.messageText }, "You may be able to lower the monthly cost of your home internet or wireless service\n                        if you are eligible for the federal government's Affordable Connectivity Program.\n                         Go to att.com/acp for details."))));
    };
    return UnauthAccess;
}(React.Component));
exports.default = UnauthAccess;
//# sourceMappingURL=UnauthAccess.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CommonCart/common/UnauthAccess/UnauthAccess.js
// module id = 422
// module chunks = 8